import { useEffect, useState } from "react";
import { IDashboardStats } from "../../models/DashboardStats";
import DashboardTile from "./DashboardTile";
import DashboardStatTableTabs from "../shared/Tabs/DashboardStatTableTabs";

const tabs = [
  { name: 'Today', value: 'today' },
  { name: 'Week' , value: 'week'  },
  { name: 'Month', value: 'month' },
];

interface IStatTableProps {
    // ----- stats ----- //
    day  : { [key: string]: number } | undefined;
    week : { [key: string]: number } | undefined; 
    month: { [key: string]: number } | undefined;
    // ----- text ----- //
    title: string;
    keyColumn: string;
    valueColumn: string;
}

export default function StatTable({ day, week, month, title, keyColumn, valueColumn }: IStatTableProps) {
  const [timeframe, setTimeframe] = useState("today");
  const [stats, setStats] = useState<{ [key: string]: number } | undefined>(undefined);

  useEffect(() => {
    if (day && week && month) {
      switch (timeframe) {
        case "today":
          setStats(day);
          break;
        case "week":
          setStats(week);
          break;
        case "month":
          setStats(month);
          break;
      }
    }
  }, [day, week, month, timeframe])

  return (
    <DashboardTile span={2}>
      <div className="p-3">
        <div className="mb-3 w-full flex justify-between">
          <div className="prose">
            <h3>{title}</h3>
          </div>
          
          <DashboardStatTableTabs
            tabs={tabs}
            value={timeframe}
            onChange={setTimeframe}
            ariaLabel="Select a tab"
          />

        </div>

        <div className="mt-6">
          <div className="flex justify-between">
            <p>{keyColumn}</p>
            <p>{valueColumn}</p>
          </div>

          <hr />

          <div className="mt-4 flex flex-col divide-y gap-y-2">
            {stats && Object.keys(stats).map((key) => {
              if (stats[key] !== 0) {
              return (
                <div key={key} className="flex justify-between pt-2 font-semibold">
                  <p className="">{key}</p>
                  <p className="font-bold text-xl text-primary-600">{stats[key]}</p>
                </div>
              )
              }
            })}
          </div>
        </div>

      </div>
    </DashboardTile>
  )

}